<div class="d-flex container-fluid1">
    <div *ngIf="!isMobile" style="width: 100%">
        <div *ngIf="isGridView" style="width: 100%">
            <div class="row topic-grid-view">
                <div class="noGyanText" *ngIf="recentSearchesList && recentSearchesList.length === 0">No Gyan Available</div>
                <div
                    *ngFor="let item of recentSearchesList | slice: startPage : itemsShowLimit; let listIndex = index"
                    id="'step'-{{ listIndex }}"
                    class="col-lg-4 col-md-6 mb-3 d-flex align-items-stretch"
                >
                    <div class="flex-fill">
                        <div
                            class="card"
                            [ngClass]="{ show: item.isSelected }"
                            [attr.id]="'go-topicoutline-card-' + listIndex"
                            [attr.data-test]="'go-topicoutline-card-' + listIndex"
                        >
                            <div class="card-body1">
                                <div
                                    class="folders foldersContainer"
                                    (click)="item.isFolder ? gotoSubFolders(item) : topicClicked($event, item)"
                                    [attr.id]="'go-topicoutline-card-item-click' + listIndex"
                                    [attr.data-test]="'go-topicoutline-card-item-click' + listIndex"
                                >
                                    <span *ngIf="item.editTopic">
                                        <span class="icon-gyan-empty"></span>
                                        <input
                                            class="form-control float-start m-1 w-80per"
                                            [(ngModel)]="newNameadvanceQueery"
                                            (blur)="onRenameAQInputBlur($event, item.topicId, item)"
                                            (keyup.enter)="onRenameAQInputBlur($event, item.topicId, item)"
                                            [attr.id]="'go-topicoutline-card-item-edit-input' + listIndex"
                                            [attr.data-test]="'go-topicoutline-card-item-edit-input' + listIndex"
                                            #renameInputAQ
                                        />
                                    </span>
                                    <span class="remove-vertical-align-middle" *ngIf="!item.editTopic">
                                        <img
                                            *ngIf="item.isFolder"
                                            class="w-3 h-1 align-items-center icon-gyan"
                                            src="../../../assets/icons/icon-folder-card.svg"
                                            alt="Folder icon"
                                        />
                                        <img
                                            *ngIf="!item.isFolder"
                                            class="w-3 h-1 align-items-center icon-gyan"
                                            src="../../../assets/organisation/icon-gyan-card.svg"
                                            alt="Gyan icon"
                                        />
                                        <!-- <span title="{{ item.topicName }}" class="topicName ellipsis-text">{{ item.topicName }}</span> -->

                                        <ng-container *ngIf="item.topicName.length > calculateNumChars(); else fullFolderName">
                                            <span [ngClass]="{ 'ellipsis-text': !isMobile, 'ellipsis-text-m': isMobile }" title="{{ item.topicName }}" class="topicName cen"
                                                >{{ item.topicName | slice: 0 : calculateNumChars() }}...</span
                                            >
                                        </ng-container>
                                        <ng-template #fullFolderName>
                                            <span [ngClass]="{ 'ellipsis-text': !isMobile, 'ellipsis-text-m': isMobile }" title="{{ item.topicName }}" class="topicName">{{
                                                item.topicName
                                            }}</span>
                                        </ng-template>

                                        <span
                                            style="align-items: center !important"
                                            *ngIf="!item.editTopic"
                                            class="gyanGridCardFolderOverlay"
                                            (click)="$event.stopPropagation()"
                                            [ngClass]="{ show: item.isSelected }"
                                        >
                                            <span
                                                class="checkIconContainer remove-vertical-align-unset"
                                                (click)="selectItem(item); $event.stopPropagation()"
                                                [attr.id]="'go-topicoutline-card-item-check-input' + listIndex"
                                                [attr.data-test]="'go-topicoutline-card-item-check-input' + listIndex"
                                            >
                                                <img
                                                    *ngIf="!item.isSelected"
                                                    class="checkIcon"
                                                    src="../../../assets/organisation/icon-check-gray.svg"
                                                    alt="Check Icon"
                                                    title="Check Icon"
                                                />
                                                <img
                                                    *ngIf="item.isSelected"
                                                    class="checkIcon hide"
                                                    src="../../../assets/organisation/icon-check-active.svg"
                                                    alt="Check Icon"
                                                    title="Check Icon"
                                                />
                                            </span>
                                        </span>
                                    </span>
                                    <div
                                        class="float-end comment-box-menu-icon"
                                        (click)="$event.stopPropagation(); onButtonClick($event)"
                                        style="margin-top: 4px"
                                        [attr.id]="'go-topicoutline-card-item-ellipses-click' + listIndex"
                                        [attr.data-test]="'go-topicoutline-card-item-ellipses-click' + listIndex"
                                    >
                                        <fa-icon style="vertical-align: middle !important" class="float-end p-1 cursor-pointer d-flex align-items-center" [icon]="faEllipsisV">
                                        </fa-icon>
                                    </div>
                                    <div class="options-box comment-box options-box-gridview folder">
                                        <ng-container *ngTemplateOutlet="menuItems; context: { $implicit: item }"> </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="!isGridView" class="d-flex" style="width: 100%">
            <div class="noGyanText" *ngIf="recentSearchesList && recentSearchesList.length === 0">No Gyan Available</div>
            <div class="container1" *ngIf="recentSearchesList && recentSearchesList.length > 0" style="width: 100%">
                <!-- <input #fileInput type="file" accept="image/jpeg, image/png, image/jpg" style="display: none" (change)="onFileSelected($event)" /> -->
                <table class="table topic-list-view">
                    <thead>
                        <tr>
                            <th scope="col" style="min-width: 25px; height: 45px; font-weight: 600; padding: 0px; vertical-align: middle"></th>
                            <th scope="col" style="min-width: 200px; padding-left: 0px; vertical-align: middle; height: 20px; font-weight: 600">Topic</th>
                            <th scope="col" style="vertical-align: middle; height: 20px; font-weight: 600">Created Date</th>
                            <th
                                scope="col"
                                style="vertical-align: middle; position: relative; width: 200px; text-align: center; padding-right: 80px; height: 20px; font-weight: 600"
                                class="text-end"
                            >
                                Action
                            </th>
                        </tr>
                    </thead>

                    <tbody class="table-group-divider pt-item">
                        <ng-container *ngFor="let item of recentSearchesList | slice: startPage : itemsShowLimit; let listIndex = index">
                            <tr
                                id="'step-' + listIndex"
                                style="position: relative"
                                class="hoverable-row"
                                [ngClass]="{ show: item.isSelected }"
                                [attr.id]="'go-topicoutline-list-' + listIndex"
                                [attr.data-test]="'go-topicoutline-list-' + listIndex"
                            >
                                <td style="min-width: 25px; padding: 0px; vertical-align: middle"></td>
                                <td
                                    style="max-width: 300px; padding-left: 0px; vertical-align: middle"
                                    (click)="item.isFolder ? gotoSubFolders(item) : topicClicked($event, item)"
                                    [attr.id]="'go-topicoutline-list-item-click' + listIndex"
                                    [attr.data-test]="'go-topicoutline-list-item-click' + listIndex"
                                >
                                    <div>
                                        <div class="title-container">
                                            <div *ngIf="!item.editTopic" class="topic-title-text title-width-list" title="{{ item.topicName }}">
                                                <img
                                                    *ngIf="item.isFolder"
                                                    class="w-3 h-1 align-items-center icon-gyan"
                                                    src="../../../assets/icons/icon-folder-card.svg"
                                                    alt="Folder icon"
                                                />
                                                <img *ngIf="!item.isFolder" class="w-3 h-1 align-items-center icon-gyan" src="../../../assets/icon-gyan-card.svg" alt="Gyan icon" />
                                                <span [ngClass]="{ 'ellipsis-text': !isMobile, 'ellipsis-text-m': isMobile }" class="topicName align-items-center">{{
                                                    item.topicName
                                                }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <span *ngIf="item.editTopic">
                                        <span class="icon-gyan-empty"></span>
                                        <input
                                            class="form-control float-start m-1 w-80per"
                                            [(ngModel)]="newNameadvanceQueery"
                                            (blur)="onRenameAQInputBlur($event, item.topicId, item)"
                                            (keyup.enter)="onRenameAQInputBlur($event, item.topicId, item)"
                                            [attr.id]="'go-topicoutline-list-item-edit-input' + listIndex"
                                            [attr.data-test]="'go-topicoutline-list-item-edit-input' + listIndex"
                                            #renameInputAQ
                                        />
                                    </span>
                                </td>
                                <td style="vertical-align: middle">
                                    <!-- <div>
                                        {{
                                            item.topicCompletedOn | date: 'longDate' : ''
                                        }}
                                    </div> -->
                                    <div>
                                        {{
                                            item.topicCompletedOn != ''
                                                ? [item.topicCompletedOn | date: 'longDate']
                                                : item.strLastEdited != ''
                                                  ? [item?.strLastEdited | date: 'longDate']
                                                  : ''
                                        }}
                                    </div>
                                </td>
                                <td style="vertical-align: middle; position: relative; width: 200px; text-align: center; padding-right: 80px">
                                    <div
                                        class="float-end comment-box-menu-icon"
                                        (click)="$event.stopPropagation(); onButtonClick($event)"
                                        [attr.id]="'go-topicoutline-list-item-ellipses-click' + listIndex"
                                        [attr.data-test]="'go-topicoutline-list-item-ellipses-click' + listIndex"
                                    >
                                        <fa-icon class="comment-box-menu-icon float-end p-1 d-flex align-items-center" [icon]="faEllipsisV"> </fa-icon>
                                    </div>
                                    <div class="options-box hem-text comment-box-mobile options-box-listview">
                                        <ng-container *ngTemplateOutlet="menuItems; context: { $implicit: item }"> </ng-container>
                                    </div>
                                </td>

                                <span
                                    style="align-items: center !important"
                                    class="pt-item gyanListOverlay"
                                    (click)="$event.stopPropagation()"
                                    [ngClass]="{ show: item.isSelected }"
                                >
                                    <span
                                        class="checkIconContainer remove-vertical-align-unset"
                                        (click)="selectItem(item); $event.stopPropagation()"
                                        [attr.id]="'go-topicoutline-card-item-check-input' + listIndex"
                                        [attr.data-test]="'go-topicoutline-card-item-check-input' + listIndex"
                                    >
                                        <img *ngIf="!item.isSelected" class="checkIconList" src="../../../assets/organisation/icon-check.svg" />
                                        <img *ngIf="item.isSelected" class="checkIconList" src="../../../assets/organisation/icon-check-active.svg" />
                                    </span>
                                </span>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <div *ngIf="isMobile" style="width: 100%">
        <div class="container1">
            <!-- <div *ngIf="isTopicLoading" class="d-flex justify-content-center align-items-center loader-container">
                <div class="loader-class d-flex flex-column justify-content-center align-items-center text-center">
                    <img src="./../../../assets/gifs/loader_sand.gif" alt="Processing icon" />
                    <span>Please wait</span>
                </div>
            </div> -->
            <div class="noGyanText" *ngIf="recentSearchesList && recentSearchesList.length === 0">No Gyan Available</div>
            <div
                *ngFor="let item of recentSearchesList | slice: startPage : itemsShowLimit; let listIndex = index"
                id="'step'-{{ listIndex }}"
                class="col-sm-12 mb-3 d-flex align-items-stretch"
            >
                <div class="flex-fill">
                    <div
                        class="card mobile"
                        [ngClass]="{ show: item.isSelected }"
                        [attr.id]="'go-topicoutline-card-' + listIndex"
                        [attr.data-test]="'go-topicoutline-card-' + listIndex"
                    >
                        <div class="card-body1">
                            <div
                                class="folders foldersContainer"
                                (click)="item.isFolder ? gotoSubFolders(item) : topicClicked($event, item)"
                                [attr.id]="'go-topicoutline-card-item-click' + listIndex"
                                [attr.data-test]="'go-topicoutline-card-item-click' + listIndex"
                            >
                                <span *ngIf="item.editTopic">
                                    <span class="icon-gyan-empty"></span>
                                    <input
                                        class="form-control float-start m-1 w-80per"
                                        [(ngModel)]="newNameadvanceQueery"
                                        (blur)="onRenameAQInputBlur($event, item.topicId, item); $event.stopPropagation(); $event.preventDefault()"
                                        (keyup.enter)="onRenameAQInputBlur($event, item.topicId, item); $event.stopPropagation(); $event.preventDefault()"
                                        [attr.id]="'go-topicoutline-card-item-edit-input' + listIndex"
                                        [attr.data-test]="'go-topicoutline-card-item-edit-input' + listIndex"
                                        #renameInputAQ
                                    />
                                </span>
                                <span class="align-items-center remove-vertical-align-middle" *ngIf="!item.editTopic">
                                    <img *ngIf="item.isFolder" class="w-3 h-1 icon-gyan" src="../../../assets/icons/icon-folder-card.svg" alt="Folder icon" />
                                    <img
                                        *ngIf="!item.isFolder"
                                        class="w-3 h-1 align-items-center icon-gyan"
                                        src="../../../assets/organisation/icon-gyan-card.svg"
                                        alt="Gyan icon"
                                    />
                                    <!-- <span title="{{ item.topicName }}" class="topicName ellipsis-text">{{ item.topicName }}</span> -->
                                    <ng-container *ngIf="item.topicName.length > calculateNumChars(); else fullFolderName">
                                        <span
                                            [ngClass]="{ 'ellipsis-text': !isMobile, 'ellipsis-text-m': isMobile }"
                                            title="{{ item.topicName }}"
                                            class="align-items-center topicName"
                                            >{{ item.topicName | slice: 0 : calculateNumChars() }}...</span
                                        >
                                    </ng-container>
                                    <ng-template #fullFolderName>
                                        <span [ngClass]="{ 'ellipsis-text': !isMobile, 'ellipsis-text-m': isMobile }" title="{{ item.topicName }}" class="topicName">{{
                                            item.topicName
                                        }}</span>
                                    </ng-template>
                                    <span
                                        style="align-items: center !important"
                                        *ngIf="!item.editTopic"
                                        class="gyanGridCardFolderOverlay show"
                                        (click)="$event.stopPropagation()"
                                        [ngClass]="{ show: item.isSelected }"
                                    >
                                        <span
                                            class="checkIconContainer remove-vertical-align-unset"
                                            (click)="selectItem(item); $event.stopPropagation()"
                                            [attr.id]="'go-topicoutline-card-item-check-input' + listIndex"
                                            [attr.data-test]="'go-topicoutline-card-item-check-input' + listIndex"
                                        >
                                            <img *ngIf="!item.isSelected" class="checkIcon" src="../../../assets/organisation/icon-check.svg" alt="Check Icon" title="Check Icon" />
                                            <img
                                                *ngIf="item.isSelected"
                                                class="checkIcon hide"
                                                src="../../../assets/organisation/icon-check-active.svg"
                                                alt="Check Icon"
                                                title="Check Icon"
                                            />
                                        </span>
                                    </span>
                                </span>
                                <div
                                    class="float-end comment-box-menu-icon"
                                    (click)="$event.stopPropagation(); onButtonClick($event)"
                                    style="margin-top: 4px"
                                    [attr.id]="'go-topicoutline-card-item-check-input' + listIndex"
                                    [attr.data-test]="'go-topicoutline-card-item-check-input' + listIndex"
                                >
                                    <fa-icon style="vertical-align: middle !important" class="float-end p-1 cursor-pointer d-flex align-items-center" [icon]="faEllipsisV">
                                    </fa-icon>
                                </div>
                                <div class="options-box comment-box options-box-gridview folder">
                                    <ng-container *ngTemplateOutlet="menuItems; context: { $implicit: item }"> </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ng-template #deleteGyanModal let-modal>
        <div class="modal-header d-flex">
            <div class="modal-title">Delete Topic</div>
            <div
                type="button"
                class="gyan-popup-close"
                aria-label="Close"
                (click)="modal.dismiss('Cross click')"
                [attr.id]="'go-delete-gyan-modal-close'"
                [attr.data-test]="'go-delete-gyan-modal-close'"
            >
                <div class="modal-close-icon"></div>
            </div>
        </div>
        <div class="modal-body1 delete-container-body">
            <div>
                <div class="my-3 px-0">
                    <div class="d-flex justify-content-center align-items-center mb-3">
                        {{ deleteMessage }}
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer delete-modal d-flex justify-content-center align-items-center">
            <button
                type="button"
                class="btn modalactionbtn"
                (click)="callDeleteGyan()"
                [attr.id]="'go-delete-gyan-modal-confirm-btn'"
                [attr.data-test]="'go-delete-gyan-modal--confirm-btn'"
            >
                Confirm
            </button>
            <button
                type="button"
                class="btn modalactionbtn"
                (click)="modal.close('Close click')"
                [attr.id]="'go-delete-gyan-modal-cancel-btn'"
                [attr.data-test]="'go-delete-gyan-modal-cancel-btn'"
            >
                Cancel
            </button>
        </div>
    </ng-template>

    <ng-template #menuItems let-item>
        <div>
            <div class="col">
                <div
                    *ngIf="editGyanPermission || CreateFolderPermission"
                    disabled="true"
                    class="comment-box-items comment-box-items-useastemplate cursor-pointer col-auto align-items-center"
                    (click)="$event.stopPropagation(); useAsTemplate(item.topicId)"
                    [attr.id]="'use-as-template-' + item.topicId"
                    [attr.data-test]="'use-as-template-' + item.topicId"
                >
                    <img class="align-items-center option-icon icon-useastemplate" src="../../../assets/icons/icon_useastemplate.svg" alt="Rename icon" title="Rename Icon" />
                    <span class="option-text option-menu-text">Use As Template</span>
                </div>
                <div
                    *ngIf="editGyanPermission || CreateFolderPermission"
                    disabled="true"
                    class="comment-box-items comment-box-items-rename cursor-pointer col-auto align-items-center"
                    (click)="$event.stopPropagation(); renameAQ(item.topicId, item)"
                    [attr.id]="'go-menu-item-edit-btn-' + item.topicId"
                    [attr.data-test]="'go-menu-edit-btn-' + item.topicId"
                >
                    <img class="align-items-center option-icon icon-rename" src="../../../assets/icons for left/icon-rename.svg" alt="Rename icon" title="Rename Icon" />
                    <span class="option-text option-menu-text">Rename</span>
                </div>
                <div
                    *ngIf="deleteGyanPermission || CreateFolderPermission"
                    disabled="true"
                    class="comment-box-items comment-box-items-delete cursor-pointer col-auto gray-color align-items-center"
                    (click)="$event.stopPropagation(); checkForDeleteGyan(item, deleteGyanModal)"
                    [attr.id]="'go-menu-item-delete-btn-' + item.topicId"
                    [attr.data-test]="'go-menu-delete-btn-' + item.topicId"
                >
                    <img class="align-items-center option-icon icon-delete icon-delete-height" src="../../../../assets/icon-delete.svg" alt="Delete icon" title="Delete Icon" />
                    <span class="option-text option-menu-text">Delete</span>
                </div>
                <div
                    *ngIf="CreateFolderPermission"
                    disabled="true"
                    class="comment-box-items comment-box-items-move cursor-pointer col-auto gray-color align-items-center"
                    (click)="$event.stopPropagation(); moveGyanItem(item)"
                    [attr.id]="'go-menu-item-move-btn-' + item.topicId"
                    [attr.data-test]="'go-menu-move-btn-' + item.topicId"
                >
                    <img class="align-items-center option-icon icon-move" src="../../../assets/organisation/icon-move.svg" alt="Move Icon" title="Move Icon" />
                    <span class="option-text option-menu-text">Move</span>
                </div>
                <div
                    *ngIf="item.showPushGyan"
                    disabled="true"
                    class="comment-box-items comment-box-items-push cursor-pointer col-auto gray-color align-items-center"
                    (click)="$event.stopPropagation(); pushToCWB(item)"
                    [attr.id]="'go-menu-item-push-btn-' + item.topicId"
                    [attr.data-test]="'go-menu-push-btn-' + item.topicId"
                >
                    <img class="align-items-center option-icon icon-push" src="../../../assets/organisation/icon-push.svg" alt="Push to CWB" title="Push to CG" />
                    <span class="option-text option-menu-text">Push to CG</span>
                </div>
            </div>
        </div>
    </ng-template>
</div>
